import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["commitmentInput", "newCommitment", "newOwnership", "newFundTotal"]
  static values = {
    otherInvestorsTotal: Number
  }

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const commitmentDollars = parseFloat(this.commitmentInputTarget.value) || 0
    const commitmentCents = commitmentDollars * 100
    const otherInvestorsCents = this.otherInvestorsTotalValue

    // Calculate new fund total
    const newFundTotalCents = otherInvestorsCents + commitmentCents

    // Calculate new ownership percentage
    const newOwnership = newFundTotalCents > 0
      ? (commitmentCents / newFundTotalCents) * 100
      : 0

    // Format currency
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })

    // Update the display
    this.newCommitmentTarget.textContent = formatter.format(commitmentDollars)
    this.newOwnershipTarget.textContent = `${newOwnership.toFixed(2)}%`
    this.newFundTotalTarget.textContent = formatter.format(newFundTotalCents / 100)
  }
}
